import * as _m0 from "protobufjs/minimal";
import { SendMessageRequest, SendMessageResponse } from "../sendmessage"; // Assumes generated file exists
import { withAuthRetry } from '../utils/authRetry';

export async function sendmessage(request: SendMessageRequest, accessToken: string, setAccessToken: (token: string | null) => void, logout: () => void): Promise<SendMessageResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const encodedRequest = SendMessageRequest.encode(request).finish();
        const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

        const params = new URLSearchParams(window.location.search);
        const staging = params.get('stagingEnv')?.toLowerCase() === 'true';

        let url = "https://li68ja5qo4.execute-api.us-west-2.amazonaws.com/intakeservice/sendmessage";
        if (staging) {
            url = `${url}-staging`;
        }

        // Retry logic for the fetch call
        const maxRetries = 3;
        let lastError: any;

        for (let attempt = 0; attempt < maxRetries; attempt++) {
            try {
                const response = await fetch(
                    url, {
                    method: 'POST',
                    headers,
                    body: base64,
                });

                // If successful response, return it
                if (response.ok) {
                    return response;
                }

                // If 5xx error, throw to trigger retry
                if (response.status >= 500) {
                    throw new Error(`Server error: ${response.status}`);
                }

                // For 4xx errors, return immediately (don't retry client errors)
                return response;

            } catch (error) {
                console.warn(`Attempt ${attempt + 1} failed:`, error);
                lastError = error;
                if (attempt < maxRetries - 1) {
                    // Exponential backoff: 500ms, 1000ms, 2000ms
                    await new Promise(resolve => setTimeout(resolve, 500 * Math.pow(2, attempt)));
                }
            }
        }

        throw lastError || new Error("Failed to send message after retries");
    };

    const decodeResponse = (bytes: Uint8Array): SendMessageResponse => {
        return SendMessageResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}
